import type { ReactElement } from 'react';

import { cn } from '@/components/ui/cn';

import { personColorIndex, type MasterListResponsible } from '../types';

/** Avatar con iniciales (color estable por persona) + nombre corto. */
export function PersonChip({ person }: { person: MasterListResponsible | null }): ReactElement {
  if (!person) {
    return <span className="dim-mono">Sin asignar</span>;
  }
  const p = personColorIndex(person.userId);
  return (
    <div className="who">
      <span className={cn('av sm', `p${p}`)} aria-hidden="true">
        {person.initials}
      </span>
      <span className="nm">{person.displayName}</span>
    </div>
  );
}
